import i18n from "i18next";

export const convertBooleanToYesOrNo = (value: boolean | undefined, withoutNo: boolean = false): string =>
  i18n.t(value ? "common_words.yes" : !withoutNo ? "common_words.no" : "");
